// this file contains field definitions for artwork section
// sections and fields are shown here in order of their appearance in CMS
// component = shows_component = means that field definition is in separate document with that name
// field_title = name under which field can be find in the CMS

export default Object.freeze({
  tabs: {
    basic: {
      title: 'Basic',
      key: 'basic',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
      role: 'basic',
      icon: 'fa-palette',
      fields: [
        {
          name: 'headline_details',
          headline: true,
          title: 'Artwork Details',
          section: 'details',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'text-short',
          name: 'accession_number',
          title: 'Accession Number',
          tag: 'accession_number',
          obligatory: true,
          desirable: true,
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'text-short',
          etype: 'autocomplete',
          name: 'artist_id',
          obligatory: true,
          desirable: true,
          related_field: 'artist_id',
          title: 'Artist (Full Artist Name)',
          table: 'artists',
          class: 'xs12',
          addNew: true,
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'text-short',
          name: 'secondary_maker',
          section: 'details',
          dynamic: true,
          title: 'Secondary Maker',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'text-long',
          name: 'title',
          title: 'Title',
          tag: 'title',
          desirable: true,
          obligatory: true,
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'text-long',
          name: 'subtitle',
          title: 'Subtitle',
          tag: 'subtitle',
          section: 'details',
          dynamic: true,
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'text-long',
          name: 'title_notes',
          title: 'Title Notes',
          section: 'details',
          dynamic: true,
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'text-short',
          name: 'production_date_new',
          title: 'Production Date',
          desirable: true,
          tag: 'production_date',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
          // 'mask': '####'
        },
        {
          ctype: 'text-auto',
          name: 'century',
          title: 'Century',
          tag: 'century',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
          // 'mask': '####'
        },
        {
          ctype: 'text-auto',
          name: 'decade',
          title: 'Decade',
          tag: 'decade',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
          // 'mask': '####'
        },
        // {
        //   'ctype': 'text-short',
        //   'name': 'production_date_end',
        //   'title': 'Production Date End',
        //   'class': 'xs12 md4',
        //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        //   'work_types_new': [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        //   'user_groups': ['admin', 'manager']
        // },
        // {
        //   'ctype': 'text-long',
        //   'name': 'production_date_text',
        //   'title': 'Production Date Text',
        //   'section': 'details',
        //   'dynamic': true,
        //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        //   'work_types_new': [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        //   'user_groups': ['admin', 'manager']
        // },
        {
          ctype: 'text-long',
          name: 'media_material_description',
          title: 'Media Material Description',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'radio',
          etype: 'select',
          selection: [
            { id: 1, value: '1', name: 'Single-channel' },
            { id: 2, value: '2', name: 'Two-channel' },
            { id: 3, value: '3', name: 'Three-channel' },
            { id: 4, value: '4', name: 'Four-channel' },
            { id: 5, value: '5', name: 'Five-channel' },
            { id: 6, value: '6', name: 'Six-channel' },
            { id: 7, value: '7', name: 'Seven-channel' },
            { id: 8, value: '8', name: 'Eight-channel' },
            { id: 9, value: '9', name: 'Nine-channel' },
            { id: 10, value: '10', name: 'Ten-channel' },
            { id: 11, value: '11', name: '11-channel' },
            { id: 12, value: '12', name: '12-channel' },
            { id: 13, value: '13', name: '13-channel' },
            { id: 14, value: '14', name: '14-channel' },
            { id: 15, value: '15', name: '15-channel' },
            { id: 16, value: '16', name: '16-channel' },
            { id: 17, value: '17', name: '17-channel' },
            { id: 18, value: '18', name: '18-channel' },
            { id: 19, value: '19', name: '19-channel' },
            { id: 20, value: '20', name: '20-channel' },
            { id: 21, value: '21', name: '21-channel' },
            { id: 22, value: '22', name: '22-channel' },
            { id: 23, value: '23', name: '23-channel' },
            { id: 24, value: '24', name: '24-channel' },
            { id: 25, value: '25', name: '25-channel' },
            { id: 26, value: '26', name: '26-channel' },
            { id: 27, value: '27', name: '27-channel' },
            { id: 28, value: '28', name: '28-channel' },
            { id: 29, value: '29', name: '29-channel' },
            { id: 30, value: '30', name: '30-channel' },
            { id: 31, value: '31', name: '31-channel' },
            { id: 32, value: '32', name: '32-channel' },
            { id: 33, value: '33', name: '33-channel' },
            { id: 34, value: '34', name: '34-channel' },
            { id: 35, value: '35', name: '35-channel' },
            { id: 36, value: '36', name: '36-channel' },
            { id: 37, value: '37', name: '37-channel' },
            { id: 38, value: '38', name: '38-channel' },
            { id: 39, value: '39', name: '39-channel' },
            { id: 40, value: '40', name: '40-channel' }
          ],
          name: 'fvs_channel_id',
          tag: 'fvs_channel_id',
          title: 'Film-channels',
          class: 'xs12',
          work_types: ['fvs'],
          work_types_new: [7, 9, 6],
          user_groups: ['admin', 'manager']
        },
        // {
        //   'ctype': 'text-long',
        //   'name': 'fvs_media_material_description',
        //   'title': 'FVS Media Material Description',
        //   'work_types': ['fvs'],
        //   'user_groups': ['admin', 'manager']
        // },
        {
          ctype: 'text-short',
          name: 'dim_height',
          title: 'Height',
          suffix: ' cm',
          class: 'xs12 md4',
          work_types: ['pppd', 'iao', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 5, 10, 6, 4, 7, 8, 9, 11],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'text-short',
          name: 'dim_frame_height',
          title: 'Height with Frame',
          suffix: ' cm',
          class: 'xs12 md6',
          work_types: ['pppd', 'iao', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'text-short',
          name: 'dim_width',
          title: 'Width',
          suffix: ' cm',
          class: 'xs12 md4',
          work_types: ['pppd', 'iao', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 5, 10, 6, 4, 7, 8, 9, 11],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'text-short',
          name: 'dim_frame_width',
          title: 'Width with Frame',
          suffix: ' cm',
          class: 'xs12 md6',
          work_types: ['pppd', 'iao', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'text-short',
          name: 'dim_depth',
          title: 'Depth',
          suffix: ' cm',
          class: 'xs12 md4',
          work_types: ['pppd', 'iao', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 5, 10, 6, 4, 7, 8, 9, 11],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'text-short',
          name: 'dim_frame_depth',
          title: 'Depth with Frame',
          suffix: ' cm',
          class: 'xs12 md6',
          work_types: ['pppd', 'iao', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'text-short',
          name: 'dim_diameter',
          title: 'Diameter',
          suffix: ' cm',
          section: 'details',
          dynamic: true,
          work_types: ['pppd', 'iao', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 5, 4, 10],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'text-long',
          name: 'dimensions_notes',
          title: 'Dimensions Notes',
          section: 'details',
          // 'dynamic': true,
          work_types: ['pppd', 'iao', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 5, 4, 10, 6, 4, 7, 8, 9, 11],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'text-short',
          name: 'series',
          title: 'Series',
          section: 'details',
          tag: 'series',
          dynamic: true,
          work_types: ['pppd', 'iao', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 5, 4, 8, 10],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'text-short',
          name: 'weight',
          title: 'Weight',
          suffix: ' kg',
          class: 'xs12 md6',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
          // },
          // {
          //   'name': 'films',
          //   'component': 'Films',
          //   'title': 'Films',
          //   'work_types': ['fvs'],
          //   'user_groups': ['admin', 'manager']
        },

        {
          ctype: 'text-short',
          name: 'edition_state',
          title: 'Edition',
          hint: 'Examples: <br> Edition 1/5 + 2 AP <br> AP 1/2 (Edition of 3)',
          work_types: ['pppd', 'iao', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'text-long',
          name: 'credit',
          title: 'Credit',
          tag: 'credit',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },

        {
          headline: true,
          title: 'System',
          section: 'system',
          no_dynamic: true,
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        // {
        //   ctype: 'toggle',
        //   selection: [
        //     { id: 'pppd', value: 'pppd', name: 'PPPD' },
        //     { id: 'iao', value: 'iao', name: 'IAO' },
        //     { id: 'fvs', value: 'fvs', name: 'FVS' },
        //     { id: 'arch', value: 'arch', name: 'ARCH' },
        //     { id: 'furn', value: 'furn', name: 'FURN' }
        //   ],
        //   name: 'classification',
        //   title: 'Classification',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        //   user_groups: ['admin', 'manager']
        // },
        // {
        //   'ctype': 'radio',
        //   'etype': 'select',
        //   'selection': [
        //     { 'id': 'drawing', 'value': 'drawing', 'name': 'Drawing'},
        //     { 'id': 'painting', 'value': 'painting', 'name': 'Painting'},
        //     { 'id': 'photo', 'value': 'photo', 'name': 'Photo / Print'},
        //     { 'id': 'arch', 'value': 'arch', 'name': 'Architecture'},
        //     { 'id': 'object', 'value': 'object', 'name': 'Object / Sculpture'},
        //     { 'id': 'furn', 'value': 'furn', 'name': 'Furniture'},
        //     { 'id': 'inst', 'value': 'inst', 'name': 'Installation'},
        //     { 'id': 'film', 'value': 'film', 'name': 'Film / Video'},
        //     { 'id': 'sound', 'value': 'sound', 'name': 'Sound'},
        //     { 'id': 'performance', 'value': 'performance', 'name': 'Performance'}
        //   ],
        //   'name': 'classification_new_id',
        //   'title': 'Type of Work OLD',
        //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        // 'work_types_new': [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 9],
        //   'user_groups': ['admin', 'manager']
        // },
        {
          // this one is adjusted according the table artwork_work_types
          ctype: 'select',
          etype: 'select',
          constant_selection: 'TYPES_OF_WORK',
          name: 'type_of_work_id',
          title: 'Type of Work',
          obligatory: true,
          desirable: true,
          tag: 'type_of_work_id',
          // selection: [
          //   { id: 1, value: 1, name: 'Drawing' },
          //   { id: 2, value: 2, name: 'Painting' },
          //   { id: 3, value: 3, name: 'Photo / Print' },
          //   { id: 5, value: 5, name: 'Architecture' },
          //   { id: 4, value: 4, name: 'Object / Sculpture' },
          //   { id: 10, value: 10, name: 'Furniture' },
          //   { id: 6, value: 6, name: 'Installation' },
          //   { id: 7, value: 7, name: 'Film / Video' },
          //   { id: 9, value: 9, name: 'Sound' },
          //   { id: 8, value: 8, name: 'Performance' },
          //   { id: 11, value: 11, name: 'Concept' }
          // ],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        // {
        //   'ctype': 'text-short',
        //   'name': 'including_other',
        //   'title': 'Other',
        //   'class': 'px-4',
        //   // 'section': 'customs',
        //   // 'dynamic': true,
        //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        // 'work_types_new': [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        //   'user_groups': ['admin', 'manager']
        // },
        
        {
          headline: true,
          title: 'Customs',
          section: 'customs',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'component',
          name: 'customs_history',
          title: 'Customs History',
          // 'table': 'artwork_location_logs',
          // 'association': 'artwork_id',
          // 'addNew': true,
          component: 'CustomsHistory',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'toggle',
          name: 'visa_status',
          title: 'Main Visa Status',
          desirable: true,
          selection: [
            { id: 'non_eu', value: 1, name: 'NON EU' },
            { id: 'eu_definite', value: 2, name: 'EU' },
            { id: 'freeport', value: 3, name: 'FREEPORT' }
          ],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'text-short',
          name: 'visa',
          title: 'Visa',
          section: 'customs',
          dynamic: true,
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'text-short',
          name: 'visa_type',
          title: 'Visa Type',
          section: 'customs',
          dynamic: true,
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'date',
          name: 'import_date',
          vernon_check: 'visa_import_export_full_details2',
          title: 'Import Date',
          format: 'YYYY-MM-DD',
          class: 'xs12',
          section: 'customs',
          dynamic: true,
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        // {
        //   'ctype': 'date',
        //   'name': 'visa_expiry_date',
        //   'title': 'Visa Expiry Date',
        //   'format': 'YYYY-MM-DD',
        //   'class': 'xs12 md6',
        //   'section': 'customs',
        //   'dynamic': true,
        //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        // 'work_types_new': [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 9],
        //   'user_groups': ['admin', 'manager']
        // },
        {
          ctype: 'text-short',
          name: 'import_taxes',
          title: 'Import Taxes',
          suffix: ' EUR',
          class: 'xs12 md6',
          section: 'customs',
          dynamic: true,
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'text-short',
          name: 'clearance_paper_number',
          title: 'Clearance Paper Number',
          class: 'xs12 md6',
          section: 'customs',
          dynamic: true,
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'text-short',
          name: 'mover_importer',
          title: 'Mover Importer',
          class: 'xs12 md6',
          section: 'customs',
          dynamic: true,
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'upload_clearance_papers',
          title: 'Upload Clearance Paper',
          section: 'customs',
          component: 'upload',
          dynamic: true,
          role: 'file_u',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager'],
          edit_only: true
        },
        {
          ctype: 'text-long',
          name: 'import_export_history',
          title: 'Import Export History',
          section: 'customs',
          dynamic: true,
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'text-long',
          name: 'import_export_notes',
          title: 'Import Export Notes',
          section: 'customs',
          dynamic: true,
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },

        {
          headline: true,
          title: 'Location',
          desirable: true,
          obligatory: true,
          section: 'location',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        // {
        //   'ctype': 'text-short',
        //   'etype': 'select',
        //   'name': 'artwork_location',
        //   'title': 'Location',
        //   'table': 'artwork_locations',
        //   'association': 'artwork_location',
        //   just_text: true,
        //   'addNew': true,
        //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        // 'work_types_new': [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        //   'user_groups': ['admin', 'manager']
        // },
        {
          ctype: 'component',
          name: 'location_history',
          title: 'Location History',
          // 'table': 'artwork_location_logs',
          // 'association': 'artwork_id',
          // 'addNew': true,
          component: 'Location',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        // {
        //   'ctype': 'text-short',
        //   'etype': 'select',
        //   'name': 'location_master_physical',
        //   'title': 'Location Master Physical',
        //   'table': 'artwork_locations',
        //   'association': 'location_master_physical',
        //   'addNew': true,
        //   'work_types': ['fvs'],
        //   'user_groups': ['admin', 'manager']
        // },
        // {
        //   'ctype': 'text-short',
        //   'etype': 'select',
        //   'name': 'location_archive_master',
        //   'title': 'Location Archive Master (digital copy of Master Physical)',
        //   'table': 'artwork_locations',
        //   'association': 'location_archive_master',
        //   'addNew': true,
        //   'work_types': ['fvs'],
        //   'user_groups': ['admin', 'manager']
        // },
        // {
        //   'ctype': 'text-short',
        //   'etype': 'select',
        //   'name': 'location_access_copy',
        //   'title': 'Location Access Copy',
        //   'table': 'artwork_locations',
        //   'association': 'location_access_copy',
        //   'addNew': true,
        //   'work_types': ['fvs'],
        //   'user_groups': ['admin', 'manager']
        // },
        // {
        //   'ctype': 'text-long',
        //   'name': 'packing_specifications',
        //   'title': 'Packing Specifications',
        //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        // 'work_types_new': [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        //   'user_groups': ['admin', 'manager']
        // },
        // 'artwork_location_copy_id': {
        //   'ctype': 'text-short',
        //   'name': 'name',
        //   'title': 'Location Copy/Replica',
        //   'table': 'artwork_locations',
        //   'association': 'artwork_location_copy'
        // },
        {
          ctype: 'text-long',
          name: 'location_notes',
          title: 'Location Notes',
          section: 'location',
          dynamic: true,
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        // 'dim_diameter': {
        //   'ctype': 'text-short',
        //   'name': 'dim_diameter',
        //   'title': 'Diameter',
        //   'suffix': ' cm'
        // },
        // 'dimensions_notes': {
        //   'ctype': 'text-long',
        //   'name': 'dimensions_notes',
        //   'title': 'Dimensions Notes'
        // },

        {
          headline: true,
          title: 'Authentication',
          no_dynamic: true,
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'text-long',
          name: 'signature',
          desirable: true,
          title: 'Signature',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          // 'ctype': 'upload',
          component: 'upload',
          name: 'certificate_new',
          desirable: true,
          category: 'artwork_certificate',
          title: 'Certificate',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager'],
          edit_only: true
        },
        {
          ctype: 'toggle',
          name: 'signature_new',
          title: 'Signed?',
          selection: [
            { id: '0', value: 0, name: 'No' },
            { id: '1', value: 1, name: 'Yes' }
          ],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        // {
        //   ctype: "text-long",
        //   name: "duration",
        //   title: "Duration",
        //   work_types: ["pppd", "iao", "fvs", "arch", "inst", "furn"],
        //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        //   user_groups: ["admin", "manager"]
        // },
        // {
        //   ctype: "text-long",
        //   name: "duration_notes",
        //   title: "Duration Notes",
        //   work_types: ["pppd", "iao", "fvs", "arch", "inst", "furn"],
        //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        //   user_groups: ["admin", "manager"]
        // },

        {
          headline: true,
          title: 'Notes',
          section: 'notes',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'text-long',
          name: 'additional_comments',
          title: 'Additional Comments',
          dynamic: true,
          section: 'notes',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },

        // {
        //   'headline': true,
        //   'title': 'Media Details',
        //   'no_dynamic': true,
        //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        // 'work_types_new': [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        //   'user_groups': ['admin', 'manager']
        // },
        // {
        //   'ctype': 'text-short',
        //   'name': 'fvs',
        //   'title': 'Container (codec video | audio',
        //   'section': 'media_details',
        //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        // 'work_types_new': [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        //   'user_groups': ['admin', 'manager']
        // },
        {
          name: 'links',
          component: 'links',
          title: 'Links',
          category: 'artwork',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        }
      ]
    },
    advanced: {
      title: 'Advanced',
      key: 'advanced',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
      role: 'adv',
      icon: 'fa-sliders-h',
      fields: [
        {
          name: 'headline_media_details',
          section: 'media_details',
          headline: true,
          title: 'Media details',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'media_details',
          ctype: 'text-long',
          title: 'Basic Narrative Description',
          hint:
            'brief description of the artwork considering the different parts and their functions / the technical aspects of the artwork / content if related to the function or needed to explain the functionality (= brief description of work and what is important)',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'dimension_details',
          ctype: 'text-long',
          title: 'Dimension Details',
          hint:
            'number of parts, list of components, including dimensions and weights',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'background_of_origin',
          etype: 'text-long',
          ctype: 'text-long',
          title: 'Description background of origin / Production process',
          section: 'media_details',
          dynamic: true,
          hint:
            'Description of how the media elements were made: eg. the work was shot on 16 mm film by the artist, the footage was telecined prior to editing... for display the gallery has provided a standard definition DVD which was encoded...)',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'frame',
          ctype: 'text-long',
          title: 'Frame',
          dynamic: true,
          section: 'media_details',
          work_types: ['pppd', 'iao', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'glass',
          ctype: 'text-long',
          title: 'Glass',
          dynamic: true,
          section: 'media_details',
          work_types: ['pppd', 'iao', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'photo_studio',
          ctype: 'text-long',
          title: 'Photo-studio',
          dynamic: true,
          section: 'media_details',
          work_types: ['pppd', 'iao', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'paper',
          ctype: 'text-long',
          title: 'Paper',
          dynamic: true,
          section: 'media_details',
          work_types: ['pppd', 'iao', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1],
          user_groups: ['admin', 'manager']
        },
        // {
        //   'name': 'electrical',
        //   'component': 'electrical',
        //   'title': 'Electrical',
        //   'work_types': ['fvs'],
        //   'user_groups': ['admin', 'manager']
        // },
        {
          ctype: 'text-long',
          name: 'exhibition_copy',
          dynamic: true,
          section: 'media_details',
          title: 'Exhibition Copy',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'toggle',
          name: 'definition',
          dynamic: true,
          section: 'media_details',
          selection: [
            { id: '1', value: 1, name: 'Standard (SD)' },
            { id: '2', value: 2, name: 'High (HD)' }
          ],
          title: 'Definition',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [6, 7, 9],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'toggle',
          name: 'color',
          dynamic: true,
          section: 'media_details',
          selection: [
            { id: '0', value: 0, name: 'No' },
            { id: '1', value: 1, name: 'Yes' }
          ],
          title: 'Color',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [6, 7, 9],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'toggle',
          name: 'sound',
          dynamic: true,
          section: 'media_details',
          selection: [
            { id: '0', value: 0, name: 'No' },
            { id: '1', value: 1, name: 'Yes' }
          ],
          title: 'Sound',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [6, 7, 9],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'toggle',
          name: 'loop',
          dynamic: true,
          section: 'media_details',
          selection: [
            { id: '0', value: 0, name: 'No' },
            { id: '1', value: 1, name: 'Yes' }
          ],
          title: 'Loop',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [6, 7, 9],
          user_groups: ['admin', 'manager']
        },
        // {
        //   ctype: "text-short",
        //   name: "language_id",
        //   dynamic: true,
        //   section: "media_details",
        //   selection: [
        //     { id: "0", value: 0, name: "No" },
        //     { id: "1", value: 1, name: "Yes" }
        //   ],
        //   vernon: false,
        //   title: "Language",
        //   work_types: ["pppd", "iao", "fvs", "arch", "inst", "furn"],
        //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        //   user_groups: ["admin", "manager"]
        // },
        {
          ctype: 'text-short',
          etype: 'autocomplete',
          dynamic: true,
          section: 'media_details',
          name: 'language_id',
          related_field: 'language_id',
          title: 'Language OLD',
          table: 'languages',
          class: 'xs12',
          addNew: false,
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [6, 7, 9],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'text-short',
          etype: 'text-short',
          dynamic: true,
          section: 'media_details',
          name: 'language',
          title: 'Language',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [6, 7, 9],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'toggle',
          name: 'fvs_subtitle',
          // dynamic: true,
          section: 'media_details',
          selection: [
            { id: '0', value: 0, name: 'No' },
            { id: '1', value: 1, name: 'Yes' }
          ],
          title: 'Subtitles',
          work_types: ['pppd', 'iao', 'fvs'],
          work_types_new: [6, 7, 9],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: 'text-long',
          name: 'fvs_subtitle_text',
          dynamic: true,
          section: 'media_details',
          title: 'Subtitle Text',
          work_types: ['pppd', 'iao', 'fvs'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 9],
          user_groups: ['admin', 'manager']
        },

        {
          name: 'headline_installation',
          headline: true,
          section: 'installation',
          title: 'Installation',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },

        {
          name: 'subheadline_installation_requirements',
          subheadline: true,
          section: 'installation_requirements',
          title: 'Requirements',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'technician',
          ctype: 'text-long',
          title:
            'Technicians, Contacts & Days for installation and de-installation',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'space_max_min',
          ctype: 'text-long',
          title: 'Space (max/min)',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'specs_on_space',
          ctype: 'text-long',
          title: 'Space (Floor, Walls, Furniture)',
          dynamic: true,
          section: 'installation',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'required_equipment',
          ctype: 'text-long',
          title: 'Technical Equipment',
          dynamic: true,
          section: 'installation',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'tools_and_gear',
          ctype: 'text-long',
          title: 'Tools & Gear',
          dynamic: true,
          section: 'installation',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'light',
          ctype: 'text-long',
          title: 'Light',
          dynamic: true,
          section: 'installation',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'climate_and_conditions',
          ctype: 'text-long',
          title: 'Climate & Conditions',
          dynamic: true,
          section: 'installation',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'power',
          ctype: 'text-long',
          title: 'Power',
          dynamic: true,
          section: 'installation',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'spare_or_replacement_parts',
          ctype: 'text-long',
          title: 'Spare or replacement parts',
          dynamic: true,
          section: 'installation',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'display_notes_and_other_special_merged',
          ctype: 'text-long',
          title: 'Other / Special',
          dynamic: true,
          section: 'installation',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager']
        },
        // {
        //   'name': 'other_special',
        //   'ctype': 'text-long',
        //   'title': 'Other / Special',
        //   'dynamic': true,
        //   'section': 'installation',
        //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        //   'work_types_new': [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 9],
        //   'user_groups': ['admin', 'manager']
        // },
        // {
        //   'name': 'display_notes',
        //   'ctype': 'text-long',
        //   'title': 'Special Requirement”',
        //   'dynamic': true,
        //   'section': 'installation',
        //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        //   'work_types_new': [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 9],
        //   'user_groups': ['admin', 'manager']
        // },
        {
          name: 'projection',
          ctype: 'text-long',
          title: 'Projection (Size, height, distance, screens)',
          dynamic: true,
          section: 'installation',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'sound_and_acoustic',
          ctype: 'text-long',
          title: 'Sound and acoustic specifications',
          dynamic: true,
          section: 'installation',
          separator: true,
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager']
        },
        // {
        //   'name': 'sound_and_acoustic',
        //   'ctype': 'flex-separator',
        //   'title': 'sound_and_acoustic',
        //   'dynamic': true,
        //   'section': 'installation',
        //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        //   'work_types_new': [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        //   'user_groups': ['admin', 'manager']
        // },

        {
          name: 'subheadline_existing_equipment',
          subheadline: true,
          section: 'installation_requirements',
          title: 'Existing Equipment',
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'existing_equipment',
          ctype: 'text-long',
          title: 'Existing Equipment',
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },

        {
          name: 'subheadline_installation_maintenance',
          subheadline: true,
          section: 'installation_maintenance',
          title: 'Maintenance',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'on_off_procedure',
          ctype: 'text-long',
          title: 'On-and Off-Procedure',
          section: 'installation',
          dynamic: true,
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'maintenance',
          ctype: 'text-long',
          title: 'Maintenance',
          section: 'installation',
          dynamic: true,
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'security_and_safety_details',
          ctype: 'text-long',
          title: 'Security and Safety Details',
          dynamic: true,
          section: 'installation',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'regular_inspection',
          ctype: 'text-long',
          title: 'Regular inspection/ Pay attention to',
          dynamic: true,
          section: 'installation',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'cleaning_artwork',
          ctype: 'text-long',
          title: 'Cleaning Artwork (how/ what products/ how often)',
          dynamic: true,
          section: 'installation',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'contacts_producers',
          ctype: 'text-long',
          title: 'Contacts / Producers',
          dynamic: true,
          section: 'installation',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager'],
          separator: true
        },

        {
          name: 'subheadline_installation_display',
          subheadline: true,
          section: 'installation_display',
          title: 'Display',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager']
        },

        {
          name: 'hanging_devices',
          ctype: 'text-long',
          title: 'Hanging Devices',
          dynamic: true,
          section: 'installation',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'specifications_on_space',
          ctype: 'text-long',
          title: 'Specification on hanging/display/ presentation in space',
          dynamic: true,
          section: 'installation',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager']
        },

        {
          name: 'subheadline_installation_manual',
          subheadline: true,
          section: 'installation_manual',
          title: 'Manual',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager']
        },
        {
          'name': 'links_installation',
          component: 'links',
          'title': 'Links',
          category: 'installation',
          sub_field: true,
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'installation_manual',
          component: 'upload',
          category: 'video_metadata',
          title: 'Video Metadata',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager'],
          // edit_only: true
        },
        {
          name: 'installation_manual',
          component: 'upload',
          category: 'instalman',
          title: 'Installation Manual',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager'],
          // edit_only: true
        },
        {
          name: 'installation_related_documents',
          component: 'upload',
          category: 'instalreq',
          title: 'Installation Related Documents',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager'],
          // edit_only: true
        },

        {
          name: 'headline_notes',
          headline: true,
          section: 'notes',
          title: 'Notes',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'statements_of_significance',
          ctype: 'text-long',
          title: 'Statements of Significance',
          dynamic: true,
          section: 'notes',
          hint:
            'based on the views of the artist, the curator, the conservator as to what is important about the work / the aim is to provide a statement which will help guide future decisions about the ongoing care and display of the work.',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'notes_merged',
          ctype: 'text-long',
          title: 'Registrar Comments',
          dynamic: true,
          section: 'notes',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'other',
          ctype: 'text-long',
          title: 'Other',
          dynamic: true,
          section: 'notes',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'correspondences',
          component: 'upload',
          title: 'Correspondences',
          category: 'artwork_corespondence',
          section: 'notes',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
          user_groups: ['admin', 'manager'],
          edit_only: true
        }
      ]
    },
    elements: {
      title: 'Elements',
      key: 'elements',
      work_types: ['fvs'],
      work_types_new: [7, 9],
      role: 'elem',
      user_rights: ['admin', 'manager'],
      icon: 'fa-plug',
      fields: [
        // {
        //   headline: true,
        //   title: "Material",
        //   no_dynamic: true,
        //   work_types: ["pppd", "iao", "fvs", "arch", "inst", "furn"],
        //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        //   user_groups: ["admin", "manager"]
        // },
        // {
        //   name: "electrical",
        //   title: "Electrical",
        //   component: "electrical",
        //   work_types: ["pppd", "iao", "fvs", "arch", "inst", "furn"],
        //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        //   user_rights: ["admin", "manager"]
        // },
        // {
        //   name: "non_electrical",
        //   title: "Non-Electrical Materials",
        //   component: "non-electrical",
        //   work_types: ["pppd", "iao", "fvs", "arch", "inst", "furn"],
        //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        //   user_rights: ["admin", "manager"]
        // },
        // // {
        // //   'name': 'films',
        // //   'title': 'Films',
        // //   'component': 'Films',
        // //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        // // 'work_types_new': [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        // //   'user_rights': ['admin', 'manager']
        // // },
        // {
        //   name: "reading_devices",
        //   title: "Reading Devices",
        //   component: "reading-devices",
        //   work_types: ["pppd", "iao", "fvs", "arch", "inst", "furn"],
        //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        //   user_rights: ["admin", "manager"]
        // },

        // {
        //   headline: true,
        //   title: "Information-Related",
        //   no_dynamic: true,
        //   work_types: ["pppd", "iao", "fvs", "arch", "inst", "furn"],
        //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        //   user_groups: ["admin", "manager"]
        // },
        // {
        //   name: "films",
        //   title: "Films",
        //   component: "Films",
        //   work_types: ["pppd", "iao", "fvs", "arch", "inst", "furn"],
        //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        //   user_rights: ["admin", "manager"]
        // },
        // {
        //   name: "audio",
        //   title: "Audio",
        //   component: "Audio",
        //   work_types: ["pppd", "iao", "fvs", "arch", "inst", "furn"],
        //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        //   user_rights: ["admin", "manager"]
        // },
        // {
        //   name: "lights",
        //   title: "Lights",
        //   component: "Light",
        //   work_types: ["pppd", "iao", "fvs", "arch", "inst", "furn"],
        //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        //   user_rights: ["admin", "manager"]
        // },
        // {
        //   name: "programme_software",
        //   title: "Programme / Software",
        //   component: "Programme",
        //   work_types: ["pppd", "iao", "fvs", "arch", "inst", "furn"],
        //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        //   user_rights: ["admin", "manager"]
        // },

        {
          headline: true,
          title: 'Information Carrier',
          no_dynamic: true,
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'information_carrier',
          title: 'Information Carrier',
          component: 'InformationCarrier',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        }
      ]
    },

    acquisition: {
      title: 'Acquisition',
      key: 'acquisition',
      role: 'acq',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [1, 2, 3, 5, 4, 6, 7, 8, 9, 10, 11, 18, 16],
      icon: 'euro',
      fields: [
        {
          name: 'headline_registration',
          headline: true,
          title: 'Registration',
          no_dynamic: true,
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'registration_date',
          ctype: 'date',
          title: 'Registration Date',
          format: 'YYYY-MM-DD',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'registrar_id',
          // 'ctype': 'text-short',
          etype: 'select',
          title: 'Registrar',
          table: 'contacts',
          association: 'registrar',
          related_field: 'registrar_id',
          column: 'category',
          add: false,
          preicon: 'person',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'acquired',
          title: 'Ownership Status',
          ctype: 'toggle',
          selection: [
            { id: 'nontba', value: 'nontba', name: 'Non-TBA' },
            { id: 'commission', value: 'commission', name: 'Commission' },
            { id: 'acquired', value: 'acquired', name: 'Acquired' },
            { id: 'com_academy', value: 'com_academy', name: 'COMMISSION TBA21-ACADEMY' }
          ],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'acquisition_method',
          title: 'Acquisition Method',
          etype: 'select',
          ctype: 'select',
          selection: [
            { id: 1, value: 1, name: 'Purchase' },
            { id: 2, value: 2, name: 'Auction sale' },
            { id: 3, value: 3, name: 'Commission' },
            { id: 4, value: 4, name: 'Gift' },
            { id: 5, value: 5, name: 'Rededication' },
            { id: 7, value: 7, name: 'Private Sale' },
            { id: 8, value: 8, name: 'Unknown' }
          ],
          condition_field: 'acquired',
          condition_value: 'acquired',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          ctype: 'date',
          name: 'acquisition_date',
          title: 'Acquisition Date',
          format: 'YYYY-MM-DD',
          condition_field: 'acquired',
          condition_value: 'acquired',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'purchase_agreement',
          title: 'Agreement',
          component: 'Upload',
          category: 'artwork_purchase',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager'],
          edit_only: true
        },

        {
          name: 'headline_provenance',
          section: 'provenance',
          headline: true,
          title: 'Provenance',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'acquisition_source_id',
          title: 'Source',
          etype: 'autocomplete',
          ctype: 'text-short',
          table: 'contacts',
          association: 'artwork_acquisition_source',
          related_field: 'acquisition_source_id',
          column: 'category',
          add: false,
          preicon: 'person',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'provenance_history',
          title: 'Provenance History',
          // 'dynamic': true,
          etype: 'text-long',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          ctype: 'text-short',
          name: 'other_reference_number',
          title: 'Other Reference Number',
          class: 'xs12',
          section: 'provenance',
          dynamic: true,
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager'],
          edit_only: true
        },

        {
          name: 'headline_system',
          headline: true,
          section: 'system',
          // 'no_dynamic': true,
          title: 'Ownership',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'ownership',
          title: 'Ownership',
          ctype: 'select',
          etype: 'select',
          selection: [
            { id: 18, value: 1, name: 'Non-TBA21' },
            { id: 1, value: 1, name: 'TBA21 Collection' },
            { id: 6, value: 6, name: 'Private Art FTB' },
            { id: 7, value: 7, name: 'Private Design FTB' },
            { id: 10, value: 10, name: 'Private Art MR' },
            { id: 17, value: 17, name: 'Private Art Collection EH' },
            { id: 19, value: 19, name: 'Private Collection FT' },
            { id: 11, value: 11, name: 'Private Collection Casa Austria' },
            { id: 12, value: 12, name: 'Gemini Masters Limited' },
            { id: 15, value: 15, name: 'Gemini Collections Limited' },
            { id: '', value: '', name: 'None' }
            // { id: 16, value: 16, name: "Gemini Collections Deaccessioned" }
            // { id: 9, value: 9, name: "Old Master" }
          ],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'ownership_history',
          title: 'Ownership history',
          ctype: 'text-long',
          etype: 'text-long',
          // 'dynamic': true,
          // 'section': 'system',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'comment_on_ownership',
          title: 'Comment on Ownership',
          ctype: 'text-long',
          etype: 'text-long',
          dynamic: true,
          section: 'system',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          ctype: 'component',
          name: 'ownership_history2',
          title: 'Ownership History',
          component: 'OwnershipHistory',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },

        {
          name: 'headline_purchase',
          headline: true,
          no_dynamic: false,
          section: 'purchase',
          title: 'Purchase',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'purchase_offer',
          // mask: '############',
          title: 'Purchase Offer',
          ctype: 'currency',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'discount',
          title: 'Discount (percentage)',
          // mask: '#####',
          suffix: ' %',
          ctype: 'text-short',
          class: 'xs12 ',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'discount_sum',
          title: 'Discount (Sum)',
          ctype: 'currency',
          // ctype: "text-short",
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        // {
        //   name: "discount_man",
        //   vernon: false,
        //   title: "Discount manually",
        //   // 'ctype': 'text-short',
        //   ctype: "currency",
        //   class: "xs12",
        //   work_types: ["pppd", "iao", "fvs", "arch", "inst", "furn"],
        //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        //   user_rights: ["admin", "manager"]
        // },

        {
          name: 'purchase_offer_vat',
          suffix: ' %',
          title: 'VAT',
          // mask: '###',
          ctype: 'text-short',
          class: 'xs12 sm4',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'vat_manual',
          title: 'VAT (Sum)',
          ctype: 'currency',
          class: 'xs12 sm8',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },

        {
          ctype: 'text-short',
          etype: 'autocomplete',
          name: 'paid_in_country',
          // related_field: 'paid_in_country',
          title: 'VAT Paid in Country',
          table: 'countries',
          class: 'xs12 mt-0 pt-0',
          addNew: false,
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },

        {
          name: 'purchased_price',
          title: 'Purchase Price',
          ctype: 'text-short',
          // mask: '############',
          etype: 'currency',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },

        {
          name: 'purchase_notes',
          title: 'Purchase Notes',
          section: 'purchase',
          dynamic: true,
          ctype: 'text-long',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        // {
        //   'name': 'invoice_number',
        //   'title': 'Invoice Number',
        //   'ctype': 'text-short',
        //   // 'etype': 'currency',
        //   'class': 'xs6 md4',
        //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        // 'work_types_new': [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        //   'user_rights': ['admin', 'manager']
        // },
        {
          name: 'invoice_date',
          title: 'Invoice Date',
          ctype: 'date',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'invoice_signed',
          title: 'Invoice Signed',
          ctype: 'bool',
          class: 'xs12 md6',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'invoice_upload',
          title: 'Invoice',
          component: 'Upload',
          category: 'artwork_invoice',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager'],
          edit_only: true
        },
        // {
        //   'name': 'invoice',
        //   'title': 'Invoice Exists',
        //   'ctype': 'bool',
        //   'class': 'xs12 md6',
        //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        // 'work_types_new': [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        //   'user_rights': ['admin', 'manager']
        // },

        {
          name: 'headline_insurance',
          headline: true,
          no_dynamic: true,
          title: 'Insurance',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          ctype: 'component',
          name: 'insurance_history',
          title: 'Insurance History',
          // 'table': 'artwork_location_logs',
          // 'association': 'artwork_id',
          // 'addNew': true,
          component: 'Insurance',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },

        {
          name: 'insurance_value',
          title: 'Insurance Value',
          // mask: '############',
          ctype: 'text-short',
          disabled: true,
          etype: 'currency',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'insurance_value_date',
          title: 'Insurance Value Date',
          ctype: 'date_separated',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'insurance_valuer',
          title: 'Insurance Valuer',
          ctype: 'text-short',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'insurance_notes',
          title: 'Insurance Notes',
          ctype: 'text-long',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'headline_market',
          headline: true,
          no_dynamic: true,
          title: 'Market Value History',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          ctype: 'component',
          name: 'market_history',
          title: 'Market Value History',
          // 'table': 'artwork_location_logs',
          // 'association': 'artwork_id',
          // 'addNew': true,
          component: 'MarketValueHistory',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },

        {
          name: 'market_value_low',
          title: 'Market Value',
          ctype: 'text-short',
          // etype: "text-short",
          class: 'xs6',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'market_value_low_currency',
          title: 'Market Value Currency',
          ctype: 'currency_only',
          // etype: "text-short",
          class: 'xs6',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'market_value_date',
          title: 'Market Value Date',
          ctype: 'date_separated',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'market_value_high',
          title: 'Market Valuer',
          ctype: 'text-short',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'market_notes',
          title: 'Market Notes',
          ctype: 'text-long',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'research_on_value',
          title: 'Research on Value',
          component: 'Upload',
          category: 'artwork_research_on_value',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager'],
          edit_only: true
        },

        {
          name: 'headline_costs',
          headline: true,
          title: 'Costs',
          no_dynamic: true,
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        // {
        //   'name': 'costs',
        //   'title': 'Costs',
        //   'ctype': 'text-short',
        //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        // 'work_types_new': [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        //   'user_rights': ['admin', 'manager']
        // },,
        {
          name: 'costs',
          title: 'Costs',
          component: 'Costs',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },

        {
          name: 'headline_loan_conditions',
          headline: true,
          title: 'Loan Conditions',
          no_dynamic: true,
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'loan_conditions',
          title: 'Loan Conditions',
          component: 'LoanConditions',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },

        {
          name: 'headline_deaccession',
          headline: true,
          no_dynamic: true,
          title: 'Deaccession',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'deaccessioned',
          title: 'Deaccessioned',
          ctype: 'bool',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'deaccession_date',
          title: 'Deaccession Date',
          ctype: 'date',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'comment_on_deaccession',
          title: 'Comment on Deaccession',
          ctype: 'text-long',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'new_ownership',
          title: 'New Ownership',
          ctype: 'text-short',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'deaccession_price_offer',
          title: 'Deaccession Price / Offer',
          ctype: 'text-short',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'deaccession_price_paid',
          title: 'Deaccession Price / Paid',
          ctype: 'text-short',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager']
        },
        {
          name: 'invoice_deaccession_papers',
          title: 'Invoice/Deaccession Papers',
          component: 'Upload',
          category: 'artwork_deaccession_papers',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager'],
          edit_only: true
        }
      ]
    },
    images: {
      title: 'Images',
      key: 'images',
      role: 'images',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
      component: 'Images',
      class: 'mt-5',
      icon: 'fa-images'
    },
    exhibition_history: {
      title: 'Exhibition History',
      key: 'exhibition_history',
      component: 'ExhibitionHistory',
      role: 'eh',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [2, 18, 3, 1, 16, 4, 5, 6, 7, 8, 9, 10],
      icon: 'fa-history'
    },
    loan_history: {
      title: 'Loan History',
      key: 'loan_history',
      component: 'LoanHistory',
      role: 'a_loan_history',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [2, 18, 3, 1, 16, 4, 5, 6, 7, 8, 9, 10],
      icon: 'fa-history'
    },
    work_history: {
      title: 'Work History',
      key: 'work_history',
      role: 'wh',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
      icon: 'fa-history',
      fields: [
        {
          name: 'production_history',
          title: 'Production History',
          component: 'Upload',
          category: 'artwork_productio_history',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_rights: ['admin', 'manager'],
          edit_only: true
        },
        {
          name: 'co_producer',
          ctype: 'text-long',
          title: 'Co-producer',
          // 'dynamic': true,
          section: 'notes',
          class: 'mt-3',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'production_credits',
          ctype: 'text-long',
          title: 'Production Credits',
          // 'dynamic': true,
          // 'section': 'notes',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'photostudio',
          ctype: 'text-long',
          title: 'Photostudio',
          // 'dynamic': true,
          // 'section': 'notes',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'developing_process',
          ctype: 'text-long',
          title: 'Developing Process',
          // 'dynamic': true,
          // 'section': 'notes',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'production_place_original',
          ctype: 'text-short',
          title: 'Production Place - Original',
          // 'dynamic': true,
          // 'section': 'notes',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'production_place_copy',
          ctype: 'text-short',
          title: 'Production Place - Copy',
          // 'dynamic': true,
          // 'section': 'notes',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'production_date_original',
          ctype: 'text-short',
          title: 'Production Date - Original',
          // 'dynamic': true,
          // 'section': 'notes',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'production_date_copy',
          ctype: 'text-short',
          title: 'Production Date - Copy/Replica',
          // 'dynamic': true,
          // 'section': 'notes',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'reason_for_production_of_copy',
          ctype: 'text-long',
          title: 'Reason for Production of Copy/Replica',
          // 'dynamic': true,
          // 'section': 'notes',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          name: 'production_notes',
          ctype: 'text-long',
          title: 'Production Notes',
          // 'dynamic': true,
          // 'section': 'notes',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        }
      ]
    },
    timeline: {
      title: 'Timeline',
      key: 'timeline',
      component: 'Timeline',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [2, 18, 3, 1, 16, 4, 5, 6, 7, 8, 9, 10, 11],
      icon: 'timeline'
    },
    texts: {
      title: 'Texts',
      key: 'texts',
      role: 'texts_tab',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
      component: 'Texts',
      icon: 'subject'
    },
    selections: {
      title: 'Selections',
      key: 'selections',
      role: 'selections',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
      component: 'Selections',
      icon: 'subject'
    },
    journals: {
      title: 'Journals',
      key: 'journals',
      role: 'journals',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
      component: 'Journals',
      icon: 'published_with_changes'
    },
    packing: {
      title: 'Packing',
      key: 'packing',
      role: 'packing',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
      component: 'Packings',
      icon: 'fa-archive'
    },
    todos: {
      title: 'Todos',
      key: 'todos',
      role: 'todos_tab',
      component: 'Todos',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [2, 18, 3, 1, 16, 4, 5, 6, 7, 8, 9, 10, 11],
      icon: 'fa-list-ol'
    },
    // films: {
    //   'title': 'Films',
    //   'key': 'films',
    //   'component': 'Films'
    // },
    tags: {
      title: 'Tags',
      key: 'tags',
      role: 'tags',
      component: 'Tags',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [2, 18, 3, 1, 16, 4, 5, 6, 7, 8, 9, 10, 11],
      icon: 'fa-tags'
    },
    conservation: {
      title: 'Conservation',
      key: 'conservation',
      role: 'cons',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
      icon: 'mdi-toolbox',
      fields: [
        {
          name: 'headline_conservation',
          no_dynamic: true,
          headline: true,
          title: 'Conservation',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
          user_groups: ['admin', 'manager']
        },
        {
          ctype: "component",
          name: "conservation",
          title: "Conservation",
          component: "Conservation",
          work_types: ["pppd", "iao", "fvs", "arch", "inst", "furn"],
          work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
          user_groups: ["admin", "manager"]
        },
        // {
        //   name: 'conservator',
        //   ctype: 'text-short',
        //   title: 'Conservator',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        //   user_groups: ['admin', 'manager']
        // },
        // {
        //   ctype: 'date',
        //   name: 'last_media_check',
        //   title: 'Last Condition Check',
        //   format: 'YYYY-MM-DD',
        //   class: 'xs12 md6',
        //   section: 'customs',
        //   dynamic: true,
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        //   user_groups: ['admin', 'manager']
        // },
        // {
        //   name: 'reason_for_update',
        //   ctype: 'text-long',
        //   title: 'Basic Conservation Description',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        //   user_groups: ['admin', 'manager']
        // }
      ]
    }
  }
})
// specifications: {
//   'ctype': 'text-long',
//   'name': 'specifications',
//   'title': 'Existing Equipment'
// },
// special_requirements: {
//   'ctype': 'text-long',
//   'name': 'special_requirements',
//   'title': 'Special Requirements'
// },

// headline_notes: {
//   'headline': true,
//   'title': 'Notes'
// },
// notes_merged: {
//   'ctype': 'text-long',
//   'name': 'notes_merged',
//   'title': 'Notes Merged'
// }



// WEBPACK FOOTER //
// ./src/data/full_user_fields.js